/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Point,
    PointFromJSON,
    PointFromJSONTyped,
    PointToJSON,
} from './Point';

/**
 * 
 * @export
 * @interface DetectionZone
 */
export interface DetectionZone {
    /**
     * 
     * @type {number}
     * @memberof DetectionZone
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof DetectionZone
     */
    name: string;
    /**
     * 
     * @type {Array<Point>}
     * @memberof DetectionZone
     */
    points: Array<Point>;
}

export function DetectionZoneFromJSON(json: any): DetectionZone {
    return DetectionZoneFromJSONTyped(json, false);
}

export function DetectionZoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): DetectionZone {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'points': ((json['points'] as Array<any>).map(PointFromJSON)),
    };
}

export function DetectionZoneToJSON(value?: DetectionZone | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'points': ((value.points as Array<any>).map(PointToJSON)),
    };
}

